import * as actions from './stats-connect.actions';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable, inject } from '@angular/core';
import { Observable, from } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { StatsService } from 'src/app/shared/services/stats.service';
import { loadingStatsConnect } from 'src/app/shared/_config/i18n/i18n-interface';
import { spxSpinnerActions } from '@softpak/components/spx-spinner';

@Injectable()
export class StatsConnectEffects {
    private readonly actions$ = inject(Actions);
    private readonly statsService = inject(StatsService);

    save: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.load),
        mergeMap(action => from(this.statsService.connect(action.query))
        .pipe(
            map(result => actions.received({
                result
            })),
            catchError((error) => [
                actions.error({
                    error
                }),
                // spxToasterActions.createError({
                //     autoClose: error.autoclose ? 5000 : undefined,
                //     messageText: error.message,
                // }),
            ])
        )))
    );

    afterLoad$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.load),
        mergeMap(() => [
            spxSpinnerActions.show({
                action: loadingStatsConnect
            }),
        ]))
    );

    afterError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.error),
        mergeMap(() => [
            spxSpinnerActions.hide({
                action: loadingStatsConnect
            }),
        ]))
    );

    afterReceived$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.received),
        mergeMap(() => [
            spxSpinnerActions.hide({
                action: loadingStatsConnect
            }),
        ]))
    );
}
